import AuthProvider from "./auth-provider";
import videojs from 'video.js';

// Базовый класс для сервисов авторизации, использующих Firebase
export default class FirebaseAuthProvider extends AuthProvider {
  constructor(name, firebaseConfig) {
    super(name);
    this.firebaseConfig = firebaseConfig;
  }

  /**
   * Статическая функция для одноразовой загрузки необходимых скриптов для Firebase и инициализации
   *
   * @param {Object} firebaseConfig - Конфигурация для инициализации Firebase
   */
  static loadScript(firebaseConfig, loadCb) {
    if (!this.loadCallbacks) this.loadCallbacks = [];
    if (loadCb) this.loadCallbacks.push(loadCb);

    if (this.loadStarted) return;
    this.loadStarted = true;

    const eventTarget = new videojs.EventTarget();

    eventTarget.on('firebaseScriptsLoaded', () => {
      if (this.appScriptLoaded && this.authScriptLoaded) {
        firebase.initializeApp(firebaseConfig);
        this.loadCallbacks.forEach(cb => cb());
      }
    });

    let appScript = document.createElement('script');
    let authScript = document.createElement('script');
    
    appScript.src = 'https://www.gstatic.com/firebasejs/8.2.9/firebase-app.js';  
    authScript.src = 'https://www.gstatic.com/firebasejs/8.2.8/firebase-auth.js';

    appScript.onload = () => {
      this.appScriptLoaded = true;
      // Подгружаем auth.js после загрузки app.js
      // Так необходимо поступать, чтобы дать время выполниться auth.js и избежать ошибки
      // Cannot instantiate firebase-auth.js - be sure to load firebase-app.js first
      document.head.append(authScript);
    };

    authScript.onload = () => {
      this.authScriptLoaded = true;
      eventTarget.trigger('firebaseScriptsLoaded');
    };

    document.head.append(appScript);
  }

  loadScript() {
    FirebaseAuthProvider.loadScript(this.firebaseConfig, () => {
      this.trigger('scriptLoaded');
    });
  }
}
